<template>
  <v-card>
    <v-list>
      <!-- 1ª parte: Avatar -->
      <v-list-item>
        <v-list-item-avatar color="primary white--text">
          {{ initialsName }}
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title class="text-truncate">
            {{ userInfo.nome_usuario }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <!-- 1ª parte END -->

      <v-divider></v-divider>

      <!-- 2ª parte: Menu Ícones -->
      <v-container>
        <v-row dense>
          <v-col cols="1"></v-col>
          <v-col cols="5">
            <v-card
              class="text-center py-3 btnMenu"
              flat
              :disabled="$route.name === 'Apostas'"
              @click="goToRoute('Apostas')"
            >
              <div>
                <v-icon large>mdi-ticket-confirmation-outline</v-icon>
              </div>
              <div>
                <div class="caption">{{ $t("bets") }}</div>
              </div>
            </v-card>
          </v-col>

          <v-col cols="5">
            <v-card
              class="text-center py-3 btnMenu"
              flat
              :disabled="$route.name === 'Mensagens'"
              @click="goToRoute('Mensagens')"
            >
              <div>
                <v-icon large>mdi-email-outline</v-icon>
                <v-badge
                  overlap
                  v-show="messagesNotRead > 0"
                  :content="messagesNotRead"
                ></v-badge>
              </div>
              <div>
                <div class="caption">{{ $t("messages") }}</div>
              </div>
            </v-card>
          </v-col>
          <v-col cols="1"></v-col>
        </v-row>

        <v-row dense>
          <v-col  cols="1"></v-col>
          <v-col cols="5">
            <v-card
              class="text-center py-3 btnMenu"
              flat
              :disabled="$route.name === 'Perfil'"
              @click="goToRoute('Perfil')"
            >
              <div>
                <v-icon large>mdi-account-circle-outline</v-icon>
              </div>
              <div>
                <div class="caption">{{ $t("profile") }}</div>
              </div>
            </v-card>
          </v-col>
          
          <v-col cols="5">
            <v-card
              class="text-center py-3 btnMenu"
              flat
              :disabled="$route.matched[0].name === 'main'"
              @click="(menu = false), $router.push('/')"
            >
              <div>
                <v-icon large>mdi-home-outline</v-icon>
              </div>
              <div>
                <div class="caption">{{ $t("goToWebsite") }}</div>
              </div>
            </v-card>
          </v-col>
          <v-col cols="1"></v-col>
        </v-row>
      </v-container>
    </v-list>
    <!-- 2ª parte: END -->

    <v-divider></v-divider>

    <!-- Footer: Sair -->
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn depressed @click="doLogout()"
        >{{ $t("exit") }} <v-icon right>mdi-exit-to-app</v-icon></v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "User",
  data: () => ({
    userInfo: "",
    firstName: "",
    initialsName: "",
    // menu: false,
  }),
  computed: {
    ...mapState(["messagesNotRead"]),
    // credit() {
    //   return this.$store.state.operators.credit;
    // },
    // retail() {
    //   return this.$store.state.operators.retail;
    // },
  },
  mounted() {
    // console.log(this.$isRetailSimplifiedOnly());
    // console.log("Retail:", this.retail);
    // console.log("Credit:", this.credit);
    this.userInfo = this.$store.state.logged.data;
  },
  watch: {
    "userInfo.nome_usuario": function(val) {
      this.initials(val);
    },
  },
  methods: {
    goToRoute(name) {
      // this.menu = false;
      this.$router.push({ name });
    },
    // Return firstName and Iniciais do Nome
    initials(name) {
      var names = name.split(" ");
      this.firstName = names[0];
      this.initialsName = names[0].substring(0, 1).toUpperCase();
      if (names.length > 1) {
        this.initialsName += names[names.length - 1]
          .substring(0, 1)
          .toUpperCase();
      }
    },
    doLogout() {
      // this.menu = false;

      if (this.$route.path.includes("/myBets")) {
        this.$router.push({ name: "main" });
      }
      this.$logout();
    },
  },
};
</script>

<style scoped>
div[role="menu"] {
  margin-top: 2.8rem;
}

.btnMenu {
  transition: 0.2s ease;
}
.btnMenu:hover {
  background-color: rgba(255, 255, 255, 0.1);
}
</style>
